<template>
    <div>
        <my-header :activeMenu="'article-index'"></my-header>
        <div class="article_main">
            <div class="banner" @click="toDetail('279')">
                <img src="@/assets/article_banner.png"/>
            </div>
            <div class="s_banner">
                <div class="s_banner_item" @click="toDetail('280')">
                    <img src="@/assets/s_banner1.jpg"/>
                </div>
                <div class="s_banner_item" @click="toDetail('281')">
                    <img src="@/assets/s_banner2.jpg"/>
                </div>
                <div class="s_banner_item" @click="toDetail('307')">
                    <img src="@/assets/s_banner3.png"/>
                </div>
            </div>
            <div class="news_box">
                <ul class="news_nav_ul">
                    <li v-for="(item,index) in tabList" :key="index" :class="activeName == item?'active':''" @click="currentTab(item)">{{item}}</li>
                </ul>
                <div class="second_menu" v-if="activeName == '快就业' || activeName == '快规划'">
                    <p @click="secondMenuClick('就业创业')" v-if="activeName == '快就业'" :class="['second_menu_item',secondActive=='就业创业'?'active':'']">就业创业</p>
                    <p @click="secondMenuClick('就业资讯')" v-if="activeName == '快就业'" :class="['second_menu_item',secondActive=='就业资讯'?'active':'']">动态资讯</p>
                    <p @click="secondMenuClick('职业生涯')" v-if="activeName == '快规划'" :class="['second_menu_item',secondActive=='职业生涯'?'active':'']">职业生涯</p>
                    <p @click="secondMenuClick('规划资讯')" v-if="activeName == '快规划'" :class="['second_menu_item',secondActive=='规划资讯'?'active':'']">动态资讯</p>
                </div>
                <div class="news_list">
                    <ul class="style1" v-if="listStyle == 1">
                        <li v-for="item in articleList" :key="item.id" @click="toDetail(item.id)">
                            <div class="news_img_box">
                                <img v-if="item.sImg" :src="item.sImg"/>
                            </div>
                            <p class="news_title">{{item.title}}</p>
                            <p class="news_introduction">{{item.discription}}</p>
                        </li>
                    </ul>
                    <ul class="style2" v-if="listStyle == 2">
                        <li v-for="item in articleList" :key="item.id" @click="toDetail(item.id)">
                            <div class="news_title">
                                <p class="news_title_name">{{item.title}}</p>
                                <p class="news_time">{{item.releaseDate?item.releaseDate.split(" ")[0]:''}}</p>
                            </div>
                            <p class="news_introduction">{{item.discription}}</p>
                        </li>
                    </ul>
                </div>
                <!--<div class="pagenation text-center">-->
                    <!--<ul>-->
                        <!--<li @click="currentPage(current -1)" v-if="current != 1"><img src="https://www.kuailework.com/plugins/website/images/Group 3 Copy@2x.png" alt=""></li>-->
                        <!--<li v-if="current>=4 ">...</li>-->
                        <!--<li @click="currentPage(item)" :class="current == item?'active':''" v-for="item in pagenationList" :key="item">{{item}}</li>-->
                        <!--<li v-if="current <= lastPage-3 ">...</li>-->
                        <!--<li v-if="lastPage > 5" @click="currentPage(current + 1)"><img src="https://www.kuailework.com/plugins/website/images/Group 3@2x.png" alt=""></li>-->
                    <!--</ul>-->
                <!--</div>-->
                <div class="pagenation_box">
                    <pagenation @current-change="currentPage" :total="total" :currentPage="current" :size="size"></pagenation>
                </div>
            </div>
        </div>
        <my-footer></my-footer>
    </div>
</template>

<script>
    import MyHeader from "@/components/common/myHeader";
    import MyFooter from "@/components/common/myFooter";
    import getData from "@/api/getData";
    import Pagenation from "../../components/pagenation";
    export default {
        name: "index",
        components: {Pagenation, MyFooter, MyHeader},
        data(){
            return{
                activeName: '名企招聘',
                tabList:['名企招聘','招考快讯','快就业','快规划','动态新闻'],
                secondActive: '',
                listStyle: 1,
                current: 1,
                size: 12,
                total: 0,
                pagenationList: [],
                lastPage: 0,
                articleList: [],
                offset: 0,
                categoryName: ''
            }
        },
        created(){
            this.categoryName = this.activeName
            this.getList()
        },
        methods:{
            currentPage(v){
                this.current = v
                this.getList()
            },
            getList(){
                getData.get('https://nocoapi.kuailework.com/api/v2/tables/mr0ixhr2uoa6v9t/records',{
                    where: '(category,eq,' + this.categoryName + ')~and' + '(show,eq,1)',
                    offset: (this.current - 1) * this.size,
                    limit: this.size,
                    sort: '-releaseDate'
                }).then(res =>{
                    if(res && res.data.list && res.data.list.length > 0){
                        this.articleList = res.data.list
                    }else{
                        this.articleList = []
                    }
                    this.total = res.data.pageInfo.totalRows
                    // this.lastPage = Math.ceil(this.total / this.size)
                    // this.setPagenationList()
                })
            },
            toDetail(id){
                // this.$router.push({
                //     name: 'article-detail',
                //     query:{
                //         id,
                //     }
                // })
                let routeData = this.$router.resolve({
                    name: 'article-detail',
                    query:{
                        id
                    }
                });
                window.open(routeData.href, '_blank');

            },
            currentTab(v){
                this.activeName = v
                if(v == '招考快讯'){
                    this.listStyle = 2
                }else{
                    this.listStyle = 1
                }
                if(v == '快就业'){
                    this.secondActive = '就业创业'
                    this.categoryName = '就业创业'
                }else if(v == '快规划'){
                    this.secondActive = '职业生涯'
                    this.categoryName = '职业生涯'
                }else{
                    this.categoryName = v
                }
                this.current = 1
                this.getList()
            },
            secondMenuClick(v){
                this.secondActive = v
                this.categoryName = v
                this.getList()
            },
            currentPage(v){
                this.current = v
                this.offset = (v-1) * this.size
                this.getList()
                this.setPagenationList()
            },
            setPagenationList(){
                let v = this.current
                if(v >= 6){
                    if(v>=3 && v<= this.lastPage-2){
                        this.pagenationList = [v-2,v-1,v,v+1,v+2]
                    }
                }else{
                    let list = []
                    for(var i=1;i<= this.lastPage;i++){
                        list.push(i)
                    }
                    this.pagenationList = list
                }
            }
        }
    }
</script>

<style scoped>
    .article_main {

    }
    ul{
        margin: 0;
        padding: 0;
    }
    li{
        list-style: none;
    }
    .banner {
        width: 100%;
        height: 450px;
        position: relative;
        overflow: hidden;
        background-color: #0F3284;
    }
    .banner img {
        left: 50%;
        height: 450px;
        transform: translateX(-50%);
        position: absolute;
    }
    .s_banner{
        width: 1200px;
        margin: 30px auto 0;
        display: flex;
        justify-content: space-between;
        background-color: #fff;
    }
    .s_banner .s_banner_item{
        width: 375px;
        height: 227px;
        background-color: #EFF6FF;
        border-radius: 14px;
        overflow: hidden;
    }
    .s_banner .s_banner_item img{
        display: block;
        width: 100%;
        height: 100%;
    }
    .news_box{
        width: 100%;
        background: #F9FCFF;
        margin-top: 30px;
        padding-bottom: 120px;
    }
    .news_nav_ul{
        width: 1200px;
        margin: 0 auto;
        padding: 30px 0 15px;
        border-bottom: 1px solid #EEEEEE;
        display: flex;
    }

    .news_nav_ul li{
        font-family: PingFangSC, PingFang SC;
        font-size: 24px;
        color: #333333;
        line-height: 20px;
        text-align: right;
        font-style: normal;
        margin-right: 50px;
        cursor: pointer;
        position: relative;
    }
    .news_nav_ul li:after{
        content: '';
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        bottom: -16px;
        height: 4px;
        border-radius: 2px;
        background: linear-gradient( 270deg, #157AFF 0%, #1478FF 100%);
        transition: width 0.3s;
    }
    .news_nav_ul li.active:after{
        width: 100%;
    }
    .news_nav_ul li:hover:after{
        width: 100%;
    }
    .news_nav_ul li.active{
        font-weight: bold;
    }
    .news_list .style1{
        display: flex;
        flex-wrap: wrap;
        width: 1200px;
        margin: 0 auto;
    }
    .news_list .style1 li{
        width: 350px;
        height: 312px;
        background: #FFFFFF;
        box-shadow: 0px 4px 8px 0px rgba(220,220,220,0.5);
        border-radius: 8px;
        margin-top: 30px;
        overflow: hidden;
        text-align: left;
        margin-right: 75px;
    }
    .news_list .style1 li:nth-child(3n){
        margin-right: 0;
    }
    .news_list li{
        cursor: pointer;
    }
    .news_list li{
        cursor: pointer;
    }
    .news_list .style1 li .news_img_box{
        height: 197px;
        background: #F4F4F4;
    }
    .news_list .style1 li .news_img_box img{
        width: 100%;
        height: 100%;
    }
    .news_list .style1 li .news_title{
        margin: 20px 15px 10px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 25px;
        text-align: justify;
        font-style: normal;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .news_list .style1 li .news_introduction{
        margin: 0 15px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        text-align: left;
        font-style: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        color: #999999;
    }
    .news_list .style2{
        background-color: #fff;
        width: 1200px;
        margin: 30px auto 0;
    }
    .news_list .style2 li{
        margin: 0 30px;
        border-bottom: 1px solid rgba(181, 181, 181, 0.3);
        overflow: hidden;
        padding-bottom: 30px;
        cursor: pointer;
    }
    .news_list .style2 li:last-child{
        border-bottom: none;
    }
    .news_list .style2 li .news_title{
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 30px 0 25px;
    }
    .news_list .style2 li .news_title .news_title_name{
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #333333;
        text-align: left;
        font-style: normal;
        width: 660px;
    }
    .news_list .style2 li .news_title .news_time{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 20px;
        text-align: center;
        font-style: normal;
    }
    .news_list .style2 li .news_introduction{
        text-align: left;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
        line-height: 26px;
        text-align: left;
        font-style: normal;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .pagenation_box{
        width: 100%;
        padding: 70px 0 0 0;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .second_menu{
        width: 1200px;
        margin: 0 auto;
        display: flex;
        padding-top: 30px;
    }
    .second_menu .second_menu_item{
        width: 131px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 0px 8px 2px rgba(220,220,220,0.5);
        border-radius: 8px;
        border: 1px solid #333333;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 20px;
        color: #333333;
        font-style: normal;
        margin-right: 40px;
        cursor: pointer;
    }
    .second_menu .second_menu_item.active{
        border-color: #1478FF;
        background-color: #1478FF;
        color: #fff;
    }
</style>